export const createEditor = (editorElem:HTMLDivElement, content?:string):void =>{
    (<any>$(editorElem)).summernote({
        codeviewIframeFilter: true,
        disableDragAndDrop: true,
        minHeight: 50,
        maxHeight: 200,
        toolbar: [
['style', ['bold', 'italic', 'underline', 'clear']],
['font', ['strikethrough']],
['color', ['color']],
['para', ['ul', 'ol', 'paragraph']]],
    }).summernote('code',content ? content : '');
}
export const destroyEditor = (editorElem:HTMLDivElement):void =>{
    (<any>$(editorElem)).summernote('destroy');
}
export const getEditorValue = (editorElem:HTMLDivElement):string =>{
    let content = <string>(<any>$(editorElem)).summernote('code');
    while(content.endsWith('<br>')) content = content.substring(0,content.length-4);
    return content;
}
export const setEditorValue = (editorElem:HTMLDivElement, content:string):void =>{
    (<any>$(editorElem)).summernote('code',content);
}
